"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactReduxI18n = require("react-redux-i18n");

var _documents = require("../../../utils/documents");

var _jsxRuntime = require("react/jsx-runtime");

var STATES = [_documents.DOCUMENT_STATE.ALMOST_EXPIRED, _documents.DOCUMENT_STATE.EXPIRED, _documents.DOCUMENT_STATE.VALID];
var TYPES = ['COV_VIGI', 'COV_VIGI_ETRANGER'];

function DocumentVersionPayrollRatio(_ref) {
  var document = _ref.document;

  if (!TYPES.includes(document.type.code) || !STATES.includes(document.state)) {
    return null;
  }

  var payrollRatio = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
    value: "document.payrollRatio.NC"
  });
  var staff = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
    value: "document.payrollRatio.NC"
  }); // Null >= 0 = true ....

  if (document.type.code === 'COV_VIGI' && (document.payroll === 0 || document.payroll > 0) && document.staff > 0) {
    payrollRatio = "".concat((document.payroll / document.staff).toFixed(0), "\u20AC");
    staff = document.staff;
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex-container mt-3",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "chip",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
        value: "document.payrollRatio.label"
      }), " ", payrollRatio]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "chip",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
        value: "document.staff"
      }), " ", staff]
    })]
  });
}

DocumentVersionPayrollRatio.propTypes = {
  document: _propTypes.default.object.isRequired
};
var _default = DocumentVersionPayrollRatio;
exports.default = _default;
//# sourceMappingURL=DocumentVersionPayrollRatio.js.map